"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  default: () => SIDRegister
});
module.exports = __toCommonJS(src_exports);
var import_ethers3 = require("ethers");
var import_sidjs2 = __toESM(require("@siddomains/sidjs"));
var import_interfaces = require("@siddomains/sidjs/dist/constants/interfaces");
var import_contract = require("@siddomains/sidjs/dist/utils/contract");

// src/utils/contract.ts
var import_ethers = require("ethers");
var import_IRegistrarController = __toESM(require("@siddomains/sid-contracts/build/contracts/IRegistrarController.json"));
function getRegistrarControllerContract({
  address,
  signer
}) {
  return new import_ethers.Contract(address, import_IRegistrarController.default, signer);
}

// src/utils/register.ts
var import_ethers2 = require("ethers");
var YEAR_IN_SECONDS = 31556952;
function calculateDuration(years) {
  return import_ethers2.BigNumber.from(parseInt((years * YEAR_IN_SECONDS).toFixed()));
}
function genCommitSecret() {
  return import_ethers2.utils.hexlify(import_ethers2.utils.randomBytes(32));
}
function getBufferedPrice(price) {
  return price.mul(110).div(100);
}

// src/utils/referral.ts
var import_sidjs = require("@siddomains/sidjs");
var emptySignature = [
  "0x0000000000000000000000000000000000000000",
  "0x0000000000000000000000000000000000000000000000000000000000000000",
  0,
  0,
  "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000"
];
function getApiUrl() {
  return "https://api.prd.space.id/v1/sign-referral";
}
function getReferralSignature(domain, chainId) {
  return __async(this, null, function* () {
    if (!domain || !chainId)
      return emptySignature;
    try {
      const res = yield fetch(getApiUrl(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          domain,
          chainId
        })
      });
      const signReferral = yield res.json();
      if (signReferral) {
        return [
          signReferral.referrerAddress,
          (0, import_sidjs.namehash)(domain),
          Number(signReferral.referralCount),
          Number(signReferral.signedAt),
          signReferral.signature
        ];
      } else {
        throw new Error("sign referral fail");
      }
    } catch (e) {
      console.error(e);
      throw new Error("sign referral fail");
    }
  });
}

// src/constants/index.ts
var ENS_COMMIT_WAIT_TIEM = 60;

// src/abi/ens.ts
var ensRegisterAbi = [
  {
    constant: true,
    inputs: [{ internalType: "string", name: "name", type: "string" }],
    name: "available",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ internalType: "bytes32", name: "commitment", type: "bytes32" }],
    name: "commit",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    name: "commitments",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      { internalType: "string", name: "name", type: "string" },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      { internalType: "bytes32", name: "secret", type: "bytes32" }
    ],
    name: "makeCommitment",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      { internalType: "string", name: "name", type: "string" },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      { internalType: "bytes32", name: "secret", type: "bytes32" },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      },
      { internalType: "address", name: "addr", type: "address" }
    ],
    name: "makeCommitmentWithConfig",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "string", name: "name", type: "string" },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      { internalType: "uint256", name: "duration", type: "uint256" },
      {
        internalType: "bytes32",
        name: "secret",
        type: "bytes32"
      }
    ],
    name: "register",
    outputs: [],
    payable: true,
    stateMutability: "payable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "string", name: "name", type: "string" },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      { internalType: "uint256", name: "duration", type: "uint256" },
      {
        internalType: "bytes32",
        name: "secret",
        type: "bytes32"
      },
      { internalType: "address", name: "resolver", type: "address" },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "registerWithConfig",
    outputs: [],
    payable: true,
    stateMutability: "payable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      { internalType: "string", name: "name", type: "string" },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "rentPrice",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  }
];
var ens_default = ensRegisterAbi;

// src/utils/index.ts
var wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// src/index.ts
var getTldByChainId = (chainId) => {
  switch (chainId) {
    case 1:
      return "eth";
    case 97:
    case 56:
      return "bnb";
    case 42161:
    case 421613:
      return "arb";
    default:
      return "bnb";
  }
};
var SIDRegister = class {
  constructor(options) {
    const { signer, sidAddress, chainId } = options;
    if (!import_ethers3.Signer.isSigner(signer))
      throw new Error("signer is required");
    if (!chainId)
      throw new Error("chainId is required");
    this.sidAddress = sidAddress != null ? sidAddress : (0, import_sidjs2.getSidAddress)(chainId);
    this.signer = signer;
    this.chainId = chainId;
  }
  getRegistrarController() {
    return __async(this, null, function* () {
      if (!this.registrarController) {
        const sidContract = (0, import_contract.getSIDContract)({
          address: this.sidAddress,
          provider: this.signer.provider
        });
        const hash = (0, import_sidjs2.namehash)(getTldByChainId(this.chainId));
        const resolverAddr = yield sidContract.resolver(hash);
        const resolverContract = (0, import_contract.getResolverContract)({
          address: resolverAddr,
          provider: this.signer.provider
        });
        const registrarControllerAddr = yield resolverContract.interfaceImplementer(
          hash,
          import_interfaces.interfaces.permanentRegistrar
        );
        if (this.chainId === 1) {
          this.registrarController = new import_ethers3.Contract(
            registrarControllerAddr,
            ens_default,
            this.signer
          );
        } else {
          this.registrarController = getRegistrarControllerContract({
            address: registrarControllerAddr,
            signer: this.signer
          });
        }
        return this.registrarController;
      }
      if (!this.registrarController)
        throw new Error("Registrar Controller is not initialized");
      return this.registrarController;
    });
  }
  getPublicResolver() {
    return __async(this, null, function* () {
      const sid = new import_sidjs2.default({ provider: this.signer.provider, sidAddress: this.sidAddress });
      if (this.chainId === 1) {
        return sid.name("resolver.eth").getAddress();
      }
      return sid.name(`sid-resolver.${getTldByChainId(this.chainId)}`).getAddress();
    });
  }
  /**
   * Get the rent price for a name.
   * @param label
   * @param year number of registration years
   */
  getRentPrice(label, year) {
    return __async(this, null, function* () {
      const normalizedName = (0, import_sidjs2.validateName)(label);
      if (normalizedName !== label)
        throw new Error("unnormailzed name");
      const registrarController2 = yield this.getRegistrarController();
      const res = yield registrarController2.rentPrice(normalizedName, calculateDuration(year));
      if (this.chainId === 1) {
        return res;
      }
      return res[0].add(res[1]);
    });
  }
  /**
   * check if the domain is available for registration
   * @param label
   */
  getAvailable(label) {
    return __async(this, null, function* () {
      const normalizedName = (0, import_sidjs2.validateName)(label);
      if (normalizedName !== label)
        throw new Error("unnormailzed name");
      const registrarController2 = yield this.getRegistrarController();
      return registrarController2.available(normalizedName);
    });
  }
  /**
   * register a domain
   * @param label
   * @param address the address to register
   * @param year
   * @param options.referrer optional parameter. the referrer domain. only work for .bnb and .arb domain
   * @param options.setPrimaryName optional parameter. register and set the domain as primary name. only work for .bnb and .arb domain
   * @param options.onCommitSuccess optional parameter. callback function when the commitment is successful. only required for .eth domain
   */
  register(label, address, year, options) {
    return __async(this, null, function* () {
      var _a, _b, _c;
      const referrer = options == null ? void 0 : options.referrer;
      const setPrimaryName = options == null ? void 0 : options.setPrimaryName;
      const normalizedName = (0, import_sidjs2.validateName)(label);
      if (normalizedName !== label)
        throw new Error("unnormailzed name");
      if (year < 1)
        throw new Error("minimum registration for one year");
      const duration = calculateDuration(year);
      const publicResolver = yield this.getPublicResolver();
      const registrarController2 = yield this.getRegistrarController();
      const secret = genCommitSecret();
      if (this.chainId === 1) {
        const commitment = yield registrarController2.makeCommitmentWithConfig(
          normalizedName,
          address,
          secret,
          publicResolver,
          address
        );
        const tx2 = yield registrarController2 == null ? void 0 : registrarController2.commit(commitment);
        yield tx2 == null ? void 0 : tx2.wait();
        const checkRes = yield registrarController2 == null ? void 0 : registrarController2.commitments(commitment);
        const createTime = (_a = checkRes == null ? void 0 : checkRes.toNumber()) != null ? _a : 0;
        if (createTime > 0) {
          if (options == null ? void 0 : options.onCommitSuccess) {
            yield options.onCommitSuccess(ENS_COMMIT_WAIT_TIEM);
          } else {
            yield wait(ENS_COMMIT_WAIT_TIEM * 1e3);
          }
        } else {
          throw new Error("commitment error");
        }
      }
      const priceRes = yield this.getRentPrice(normalizedName, year);
      const bufferedPrice = getBufferedPrice(priceRes);
      let tx;
      if (this.chainId === 1) {
        const gas = yield (_b = registrarController2.estimateGas) == null ? void 0 : _b.registerWithConfig(
          normalizedName,
          address,
          duration,
          secret,
          publicResolver,
          address,
          {
            value: bufferedPrice
          }
        );
        const gasLimit = (gas != null ? gas : import_ethers3.BigNumber.from(0)).add(21e3);
        tx = yield registrarController2 == null ? void 0 : registrarController2.registerWithConfig(
          normalizedName,
          address,
          duration,
          secret,
          publicResolver,
          address,
          {
            value: bufferedPrice,
            gasLimit: gasLimit ? import_ethers3.BigNumber.from(gasLimit) : void 0
          }
        );
      } else {
        const referralSign = yield getReferralSignature(referrer != null ? referrer : "", this.chainId);
        const gas = yield (_c = registrarController2.estimateGas) == null ? void 0 : _c.registerWithConfigAndPoint(
          normalizedName,
          address,
          duration,
          publicResolver,
          false,
          setPrimaryName,
          referralSign,
          {
            value: bufferedPrice
          }
        );
        const gasLimit = (gas != null ? gas : import_ethers3.BigNumber.from(0)).add(21e3);
        tx = yield registrarController2.registerWithConfigAndPoint(
          normalizedName,
          address,
          duration,
          publicResolver,
          false,
          setPrimaryName,
          referralSign,
          {
            value: bufferedPrice,
            gasLimit
          }
        );
      }
      yield tx.wait();
      return normalizedName;
    });
  }
};
